import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { map } from 'rxjs/operators';
import { HttpService } from '../../@core/backend/common/api/http.service';

@Component({
  selector: 'ngx-view-attachment',
  templateUrl: './view-attachment.component.html',
  styleUrls: ['./view-attachment.component.scss']
})
export class ViewAttachmentComponent implements OnInit {
  @Input() fileId: string;

  @ViewChild('pdfViewer', { static: true }) pdfViewer: any;

  constructor(
    public dialogRef: NbDialogRef<ViewAttachmentComponent>,
    private api: HttpService) { }
  ngOnInit() {
    if (this.fileId) {
      this.downloadFile(`attachments/${this.fileId}`).subscribe(
        (res) => {
          this.pdfViewer.pdfSrc = res; // pdfSrc can be Blob or Uint8Array
          this.pdfViewer.refresh(); // Ask pdf viewer to load/refresh pdf
        }
      );
    }
  }


  private downloadFile(url: string): any {
    return this.api.get(url, { responseType: 'blob' })
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }
  onCancelClick(): void {
    this.dialogRef.close();
  }



}
